import { useActiveEvent } from './ActiveEventContext';

export function useIsEventDay() {
  const activeEvent = useActiveEvent();
  return !!activeEvent;
}
